import { render } from "./BlastSpecialUpdates.vue?vue&type=template&id=88dc0984&scoped=true"
const script = {}

import "./BlastSpecialUpdates.vue?vue&type=style&index=0&id=88dc0984&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88dc0984"]])

export default __exports__